<template>
  <md-card>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4 class="card-title">Datos de Cuadrilla</h4>
        </div>
        <form class="md-layout-item" id="customer_form" @submit.prevent="saveCustomer()">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-50">
              <md-field :class="validationClass('name')">
                <label for="name">Nombre de Cuadrilla</label>
                <md-input
                  data-vv-name="name"
                  v-validate="modelValidations.name"
                  v-model="updatedItem.name"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-medium-size-50">
              <md-field :class="validationClass('residentHighway')">
                <label for="residentHighway">Residente de Vialdiades</label>
                <md-select
                  data-vv-name="residentHighway"
                  v-validate="modelValidations.residentHighway"
                  v-model="updatedItem.attendantId"
                  name="customer_type"
                >
                  <md-option
                    v-for="revi in metasRevi"
                    :value="revi.id"
                    :key="revi.id"
                  >{{revi.name}} {{revi.id}}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div class="md-layout" v-if="crewCreate">
            <div class="md-layout-item md-size-100">
              <staff :idCrew="updatedItem.id" :workers="updatedItem.workers"></staff>
            </div>
          </div>
        </form>
      </div>
    </md-card-content>
    <md-card-actions class="md-layout md-alignment-top-right">
      <md-button @click="$router.go(-1)" class="md-warning md-layout-item md-size-10">Cancelar</md-button>
      <div class="md-layout-item md-size-10"></div>
      <md-button
        type="submit"
        form="customer_form"
        class="md-success md-layout-item md-size-10"
      >Aceptar</md-button>
      <div class="md-layout-item md-size-5"></div>
    </md-card-actions>
  </md-card>
</template>

<script>
import { mapState } from "vuex";
import catalogService from "@/services/catalog";
import usersService from "@/services/user";
import Staff from "./Staff";
import setsPageTitleMixin from "@/mixins/setsPageTitle";

const modelValidations = {
  name: {
    required: true,
  },
  residentHighway: {
    required: true,
  },
};

export default {
  name: "EditCrew",

  components: {
    Staff,
  },

  props: {
    crew: {},
    title: {
      type: String,
      default: "Crear Cuadrilla",
    },
  },

  mixins: [setsPageTitleMixin],

  computed: {
    pageTitle() {
      const verb = this.updatedItem.id ? "Editar" : "Crear";

      return `${verb} Cuadrilla.`;
    },
  },

  data() {
    return {
      updatedItem: {},
      modelValidations,
      defaultItem: {
        isActive: true,
      },
      metasRevi: [],
      crewCreate: false,
    };
  },
  methods: {
    saveCustomer() {
      const payload = { original: this.crew, updated: this.updatedItem };

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", payload);
        }
      });
    },

    consultMetasCatalogs(ruta, asign, arg) {
      // Make query for metaDatas
      catalogService.fetch(ruta, { id: arg, noStore: true }).then((res) => {
        this[asign] = res;
      });
    },

    consultMetasUsers(ruta, asign, arg) {
      // Make query for metaDatas
      usersService.fetchType(ruta).then((res) => {
        this[asign] = res;
      });
    },
  },
  created() {
    this.updatedItem = { ...this.defaultItem, ...this.crew };
    this.consultMetasUsers("revi", "metasRevi");
    this.crewCreate = this.updatedItem.id ? true : false;
  },

  watch: {
    $route(to, from) {
      this.updatedItem = { ...this.defaultItem, ...this.crew };
      this.crewCreate = this.updatedItem.id ? true : false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Catalogs/Crews/Edit.vue